module.exports = __webpack_public_path__ + "img/contact_a02.f9d7357e.png";